/**
 * Icon lookup BY STRING NAME — data (collections, promises, socials) can only
 * store strings in a database, never React components.
 * Adding an icon: import it from lucide-react, then add one line to `icons`.
 */
import {
  ArrowRight, ArrowUpRight, BadgeCheck, Check, ChevronDown, ChevronLeft, ChevronRight,
  CircleHelp, Clock, Compass, Facebook, Gem, Globe, Inbox, Instagram, Layers, Link2,
  LockKeyhole, LogOut, Mail, MapPin, Menu, Moon, Package, Pencil, Phone, Plus, Search,
  Send, Settings2, SlidersHorizontal, Sparkles, Star, Sun, Trash2, Watch, Wrench, X, Youtube,
  type LucideIcon,
} from 'lucide-react'

export const icons: Record<string, LucideIcon> = {
  ArrowRight, ArrowUpRight, BadgeCheck, Check, ChevronDown, ChevronLeft, ChevronRight,
  Clock, Compass, Facebook, Gem, Globe, Inbox, Instagram, Layers, Link2, LockKeyhole,
  LogOut, Mail, MapPin, Menu, Moon, Package, Pencil, Phone, Plus, Search, Send,
  Settings2, SlidersHorizontal, Sparkles, Star, Sun, Trash2, Watch, Wrench, X, Youtube,
}

/** Look an icon up by name; an unknown name yields a question mark, never a crash. */
export function getIcon(name: string): LucideIcon {
  return icons[name] ?? CircleHelp
}
